var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.02a3.999 3.999 0 015.653 5.642l-5.654 5.661-5.651-5.661A4.001 4.001 0 018 3.019zm4.552 1.093a2.665 2.665 0 00-3.66-.102l-.89.799-.891-.798a2.666 2.666 0 00-3.79 3.737L8 12.436l4.68-4.687a2.667 2.667 0 00-.13-3.636z"
  })));
}

export default SvgLike;